import { render, staticRenderFns } from "./EmissionCard.vue?vue&type=template&id=5d75a580&"
import script from "./EmissionCard.vue?vue&type=script&lang=js&"
export * from "./EmissionCard.vue?vue&type=script&lang=js&"
import style0 from "./EmissionCard.vue?vue&type=style&index=0&id=5d75a580&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports